import { html } from 'lit';

export const iconExcel = html`
  <svg
    width="14"
    height="19"
    viewBox="0 0 14 19"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path
      d="M12.832 3.55469C13.2539 3.97656 13.5 4.53906 13.5 5.13672V16C13.5 17.2656 12.4805 18.25 11.25 18.25H2.25C0.984375 18.25 0 17.2656 0 16V2.5C0 1.26953 0.984375 0.25 2.25 0.25H8.61328C9.21094 0.25 9.77344 0.496094 10.1953 0.917969L12.832 3.55469ZM11.8125 16H11.7773V5.875H9C8.36719 5.875 7.875 5.38281 7.875 4.75V1.97266H2.25C1.93359 1.97266 1.6875 2.21875 1.6875 2.53516V16C1.6875 16.3164 1.93359 16.5625 2.25 16.5625H11.25C11.5312 16.5625 11.8125 16.3164 11.8125 16ZM8.05078 8.47656C8.33203 8.08984 8.85938 8.01953 9.21094 8.33594C9.59766 8.61719 9.66797 9.14453 9.35156 9.49609L7.80469 11.5L9.35156 13.5391C9.66797 13.8906 9.59766 14.418 9.21094 14.6992C9.07031 14.8398 8.89453 14.875 8.71875 14.875C8.4375 14.875 8.19141 14.7695 8.05078 14.5586L6.75 12.9062L5.41406 14.5586C5.23828 14.7695 4.99219 14.875 4.74609 14.875C4.57031 14.875 4.39453 14.8398 4.25391 14.6992C3.86719 14.418 3.79688 13.8906 4.11328 13.5391L5.66016 11.5L4.11328 9.49609C3.79688 9.14453 3.86719 8.61719 4.25391 8.33594C4.60547 8.01953 5.13281 8.08984 5.41406 8.47656L6.75 10.1289L8.05078 8.47656Z"
    />
  </svg>
`;
